const ScoutingCenterGameIdPlayersPage = () => {
  return <div>Coming soon</div>;
};

export default ScoutingCenterGameIdPlayersPage;
